// TargetVsAchieved.tsx
import { Card, Typography, Row, Col } from 'antd';
import React from 'react';

const { Title } = Typography;

// Mock data structure
const mockData = [
    { month: 'Jan', target: 78, achieved: 76 },
    { month: 'Feb', target: 79, achieved: 76.5 },
    { month: 'Mar', target: 77, achieved: 76 },
    { month: 'Apr', target: 80, achieved: 79 },
];

const TargetVsAchieved: React.FC = () => (
    <Card title={<Title level={4} style={{ margin: 0 }}>Target vs Achieved</Title>} style={{ height: '100%', width: '100%' }}>
        {/* Placeholder for the Bar Chart */}
        <div style={{ height: 260, padding: '10px 0' }}>
            {/* Y-axis labels */}
            <div style={{ position: 'absolute', left: 24, top: 70, fontSize: 12 }}>
                <p style={{ margin: '30px 0' }}>80k</p>
                <p style={{ margin: '30px 0' }}>70k</p>
                <p style={{ margin: '30px 0' }}>60k</p>
                <p style={{ margin: '30px 0' }}>50k</p>
            </div>

            {/* Bar Chart Area */}
            <Row gutter={[20, 0]} justify="space-around" style={{ height: '100%', paddingLeft: 40, alignItems: 'flex-end' }}>
                {mockData.map((data, index) => (
                    <Col key={index} style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-end', height: 180 }}>
                            <div
                                style={{
                                    width: 20,
                                    height: `${(data.target - 50) * 100 / 30}%`, // Scaling between 50k and 80k
                                    backgroundColor: '#722ED1', // Target (Purple)
                                    marginRight: 4,
                                    borderRadius: 2
                                }}
                            ></div>
                            <div
                                style={{
                                    width: 20,
                                    height: `${(data.achieved - 50) * 100 / 30}%`, // Scaling between 50k and 80k
                                    backgroundColor: '#FA8C16', // Achieved (Orange)
                                    borderRadius: 2
                                }}
                            ></div>
                        </div>
                        <p style={{ margin: '5px 0 0 0' }}>{data.month}</p>
                    </Col>
                ))}
            </Row>
        </div>

        {/* Legend */}
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                <div style={{ width: 10, height: 10, backgroundColor: '#722ED1', marginRight: 8 }}></div>
                <p style={{ margin: 0 }}>Target</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: 10, height: 10, backgroundColor: '#FA8C16', marginRight: 8 }}></div>
                <p style={{ margin: 0 }}>Achieved</p>
            </div>
        </div>
    </Card>
);

export default TargetVsAchieved;